<template>
  <div>

    <h2>Получить предварительный расчет загруженных ДО</h2>
    <p>Нужно выбирать бины или населенный пункт. Расчетный месяц и год выбрать нужно обязательно</p>
    <div class="row g-3">

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="timesheetType" class="form-label col-md-3">Тип табеля</label>
          <div class="col-md-9">
            <div class="input-group">
              <multiselect
                  v-model="timesheetType"
                  :options="timesheetTypeList"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="formattedTimesheetTypeLabel"
                  placeholder="Выберите тип табеля"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="katoCode" class="form-label col-md-3">Населенный пункт</label>
          <div class="col-md-9">
            <div class="input-group">
              <multiselect
                  v-model="kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="binList" class="form-label col-md-3">Список БИНов (пишите через запятую или один за другим)</label>
          <div class="col-md-9">
            <div class="input-group">
              <textarea id="binList" cols="30" rows="10" class="form-control" v-model="binList"
placeholder="1234567, 1234567, ...
или
1234567
1234567
..."></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingMonth" class="form-label col-md-3">Расчетный месяц</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min='1' max='12' step="1" class="form-control" id="accountingMonth" required v-model="accountingMonth">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingYear" class="form-label col-md-3">Расчетный год</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min='2024' step="1" class="form-control" id="accountingYear" required v-model="accountingYear">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <button class="btn btn-primary" @click="fetchPreCalculation">Поиск</button>
          <button v-if="!isPreCalculationLoading" class="btn btn-warning" @click="clearSearchParam()">Сбросить фильтр</button>
          <button v-else class="btn btn-loading" disabled>Загрузка</button>
          <button class="btn btn-info" @click="fetchRunPreCalculationAmount">Запустить предварительный расчет по выбранному фильтру</button>
        </div>
      </div>
      <div class="page-content-info d-flex align-items-center justify-content-end">
        <label class="me-3 mb-0">
          <input type="checkbox" v-model="onlyWithoutPdf"> Только без PDF
          <span v-if="kindergartenDetailResponse.length">(без PDF: {{ withoutPdfCount }} из {{ kindergartenDetailResponse.length }})</span>
        </label>
        <button :disabled = "(kindergartenDetailResponse.length === 0) || isDownloading"  class="btn btn-info align-items-center justify-content-end" @click="downloadGeneratedPreCalculationTimesheetList()">
          <template v-if="isDownloading">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Формируется файл...
          </template>
          <template v-else>Выгрузить результат по фильтру</template>
        </button>
      </div>

    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="number" label="№"></el-table-column>
      <el-table-column label="Текст ошибки">
        <template #default="scope">
          <span style="color: red">{{ scope.row.errorText }}</span>
        </template>
      </el-table-column>
      <el-table-column label="PDF">
        <template #default="scope">
          <span :class="pdfStatusClass(scope.row.pdfStatus)">{{ pdfStatusLabel(scope.row.pdfStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bin" label="БИН"></el-table-column>
      <el-table-column prop="name" label="Название ДО"></el-table-column>
      <el-table-column prop="lmsId" label="LMS ID"></el-table-column>
      <el-table-column prop="katoNameRu" label="Населенный пункт"></el-table-column>
      <el-table-column label="Предварительный расчет ФЦ с перерасчет">
        <template #default="scope">
          <p
              :class="{
            'text-danger': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) > 1000,
            'text-warning': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) < 1000 && Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) > 0,
            'text-success': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) == 0,
            }"
          >
            {{ scope.row.totalSumFc }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Расчет LMS с перерасчет">
        <template #default="scope">
          <p
              :class="{
            'text-danger': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) > 1000,
            'text-warning': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) < 1000 && Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) > 0,
            'text-success': Math.abs(scope.row.totalSumFc - scope.row.totalSumLms) == 0,
            }"
          >
            {{ scope.row.totalSumLms }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Предварительный расчет ФЦ без перерасчет" prop="sumFc"></el-table-column>
      <el-table-column label="Расчет LMS без перерасчет" prop="sumLms"></el-table-column>
      <el-table-column label="Лимит" prop="limitFc"></el-table-column>
      <el-table-column label="Сумма перерасчета LMS" prop="recalculationLms"></el-table-column>
      <el-table-column label="Сумма перерасчета ФЦ" prop="recalculationFc"></el-table-column>
      <el-table-column label="Кол-во по проектной мощности" prop="childrenCapacity"></el-table-column>
      <el-table-column label="Время последнего расчёта" prop="lastCalculationDate"></el-table-column>
      <el-table-column label="LMS Document Id" prop="lmsDocumentId"></el-table-column>
      <el-table-column label="Кол-во записей" prop="timesheetCount"></el-table-column>
    </el-table>

  </div>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, ref} from "vue";
import Multiselect from "vue-multiselect";
import {Kato, TimesheetType} from "@/types/kindergarten";
import {SearchParam} from "@/types/searchParam";
import cacheService from "@/services/cacheService";
import {KindergartenDetailResponse} from "@/types/lmsService";
import {getGeneratedPreCalculationTimesheetList} from "@/services/reportService";
import {getPreCalculationList, runPreCalculationAmount} from "@/services/kindergartenService";

export default defineComponent({
  name: "PreCalculationTimesheetView",
  components: {Multiselect},
  setup() {
    const kato = ref<Kato | null>(null);
    const timesheetType = ref<TimesheetType | null>(null);
    const binList = ref<string | null>(null);
    const accountingMonth = ref<number | null>(new Date().getMonth() + 1);
    const accountingYear = ref<number | null>(new Date().getFullYear());
    const searchParam = ref<SearchParam>();
    const isPreCalculationLoading = ref<boolean>(false);
    const isDownloading = ref<boolean>(false);
    const katoList = ref<Kato[]>([]);
    const timesheetTypeList = ref<TimesheetType[]>([]);
    const kindergartenDetailResponse = ref<KindergartenDetailResponse[]>([]);

    const onlyWithoutPdf = ref<boolean>(false);
    const isWithoutPdf = (item: KindergartenDetailResponse) => !item.pdfStatus || item.pdfStatus === 'NONE';
    const withoutPdfCount = computed(() => kindergartenDetailResponse.value.filter(isWithoutPdf).length);
    const tableData = computed(() => onlyWithoutPdf.value
        ? kindergartenDetailResponse.value.filter(isWithoutPdf)
        : kindergartenDetailResponse.value);

    const pdfStatusLabel = (status: string) => ({
      GENERATING: 'Формируется',
      NOT_SIGNED: 'Сформирован',
      SIGNED: 'Подписан',
      ERROR: 'Ошибка',
    } as Record<string, string>)[status] || 'Нет PDF';

    const pdfStatusClass = (status: string) => ({
      'text-danger': status === 'ERROR',
      'text-warning': !status || status === 'NONE' || status === 'GENERATING',
      'text-success': status === 'NOT_SIGNED' || status === 'SIGNED',
    });

    const fetchCachedData = async () => {
      katoList.value = await cacheService.useKatoStore().fetchKato();
      timesheetTypeList.value = await cacheService.useTimesheetType().fetchTimesheetType();
      timesheetType.value = timesheetTypeList.value.find(item => item.code === 1) || null;
    };

    const clearSearchParam = () => {
      kato.value = null;
      binList.value = null;
      accountingMonth.value = new Date().getMonth() + 1;
      accountingYear.value = new Date().getFullYear();
    }

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    const formattedTimesheetTypeLabel = (item: any) => {
      return `${item.code} | ${item.name}`;
    }

    const fetchPreCalculation = async () => {
      try {
        if ((binList.value && binList.value != "") || kato.value) {
          if (accountingMonth.value && accountingYear.value) {
            isPreCalculationLoading.value = true;
            const filter : Record<string, any> = {};
            filter["binList"] = binList.value;
            filter["katoCode"] = kato.value?.code;
            filter["accountingMonth"] = accountingMonth.value;
            filter["accountingYear"] = accountingYear.value;
            filter["timesheetType"] = timesheetType.value?.code;
            searchParam.value = {
              countInPage: 0,
              partNumber: 0,
              sort: {},
              filter
            }
            kindergartenDetailResponse.value = await getPreCalculationList(searchParam.value);
            isPreCalculationLoading.value = false;
          }
        }
      } catch (error) {
        console.error(error);
        isPreCalculationLoading.value = false;
      }
    }

    const fetchRunPreCalculationAmount = async () => {
      try {
        if (kindergartenDetailResponse.value) {
          const monthlyTimesheetIds = kindergartenDetailResponse.value.map(item => item.monthlyTimesheetId);
          await runPreCalculationAmount(monthlyTimesheetIds);
          isPreCalculationLoading.value = false;
          location.reload();
        }
      } catch (error) {
        console.error(error);
        isPreCalculationLoading.value = false;
      }
    }

    const downloadGeneratedPreCalculationTimesheetList = async () => {
      if (isDownloading.value) return;
      isDownloading.value = true;
      try {
        const filter: Record<string, any> = {};
        filter["binList"] = binList.value;
        filter["katoCode"] = kato.value?.code;
        filter["accountingMonth"] = accountingMonth.value;
        filter["accountingYear"] = accountingYear.value;
        filter["timesheetType"] = timesheetType.value?.code;
        filter["onlyWithoutPdf"] = onlyWithoutPdf.value;
        searchParam.value = {
          countInPage: 0,
          partNumber: 0,
          sort: {},
          filter
        }

        await getGeneratedPreCalculationTimesheetList(searchParam.value);
      } catch (error) {
        console.error(error);
      } finally {
        isDownloading.value = false;
      }
    }

    onMounted(() => {
      fetchCachedData();
    });
    return {
      kato,
      timesheetType,
      binList,
      accountingMonth,
      accountingYear,
      katoList,
      timesheetTypeList,
      isPreCalculationLoading,
      isDownloading,
      kindergartenDetailResponse,
      onlyWithoutPdf,
      withoutPdfCount,
      tableData,
      pdfStatusLabel,
      pdfStatusClass,
      clearSearchParam,
      formattedKatoLabel,
      formattedTimesheetTypeLabel,
      fetchPreCalculation,
      fetchRunPreCalculationAmount,
      downloadGeneratedPreCalculationTimesheetList
    };
  },
});
</script>

<style scoped>

.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}

</style>